import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { loginUser } from "../api";
import axios from "axios";
import "../assets/css/global.css";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [companies, setCompanies] = useState([]); // Aziende disponibili per l'utente
  const [selectedCompany, setSelectedCompany] = useState(""); // Azienda selezionata
  const [error, setError] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null); // Timeout per debounce
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const errorParam = queryParams.get("error");
    if (errorParam) {
      setError(errorParam);
    }
  }, [location]);

  // 🔹 Funzione con debounce per evitare richieste continue
  const handleUsernameChange = (e) => {
    const enteredUsername = e.target.value;
    setUsername(enteredUsername);

    if (typingTimeout) {
      clearTimeout(typingTimeout); // Cancella il timeout precedente
    }

    if (enteredUsername.length > 2) {
      setTypingTimeout(
        setTimeout(() => {
          fetchCompanies(enteredUsername);
        }, 500) // Imposta il ritardo a 500ms
      );
    } else {
      setCompanies([]); // Se l'input è troppo corto, svuota la lista aziende
    }
  };

  // 🔹 Funzione per recuperare le aziende associate all'utente
  const fetchCompanies = async (username) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/companies/${username}`);
      setCompanies(response.data);
    } catch (error) {
      setCompanies([]); // Se non trova aziende, svuota la lista
      setError("Nessuna azienda trovata.");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await loginUser({ company: selectedCompany, username, password });
      if (response.data.user) {
        localStorage.setItem("user", JSON.stringify(response.data.user));
        navigate("/dashboard");
      } else {
        setError("Credenziali errate.");
      }
    } catch (err) {
      setError("Credenziali errate.");
    }
  };

  return (
    <main className="login_container">
      <div className="login_wrapper">
        <div className="logo_container">
          <div className="logo_img"></div>
          <div className="logo_wrt"></div>
        </div>
        <div className="login_form">
          <h1>Login</h1>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <form onSubmit={handleLogin}>
            <div className="input_group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                name="username"
                placeholder="Inserisci l'utente"
                autoComplete="username"
                value={username}
                onChange={handleUsernameChange}
                required
              />
            </div>
            <div className="input_group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Inserisci la password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="input_group">
              <label htmlFor="company">Azienda</label>
              <select
                id="company"
                name="company"
                autoComplete="organization"
                value={selectedCompany}
                onChange={(e) => setSelectedCompany(e.target.value)}
                required
              >
                <option value="">Seleziona un'azienda</option>
                {companies.length > 0 ? (
                  companies.map((company) => (
                    <option key={company.id} value={company.id}>
                      {company.name}
                    </option>
                  ))
                ) : (
                  <option disabled>Nessuna azienda trovata</option>
                )}
              </select>
            </div>
            <button className="button" type="submit">Login</button>
          </form>
          <a href="/forgot-password">Dimenticato la Password?</a>
        </div>
      </div>
    </main>
  );
}

export default Login;